<template>
    <div id="chiocevote" ref="cxcontent">
        <div id="headers" v-if="!iframeId">
            <!-- <i class="arr" @click="goBack()"></i> -->
            <p class="title">{{title}}</p>
        </div>
        <div class="setFix"></div>
        <div class="chioceBox">
            <!-- 单选投票进行时 -->
            <div class="singleBox">
                <!-- 过期的提示框 -->
                <p class="outDate toutDate" v-if="isEnd">投票已过期</p>
                <!-- 管理员 -->
                <div v-if="isAdmin">
                    <p class="title2">{{poll.title}}{{poll.type==1?'（多选）':'（单选）'}}</p>
                    <p class="title title2 desc">{{poll.info}}</p>
                    <div v-if="poll.type==0">
                        <mt-radio
                            @change="single"
                            v-model="value"
                            title=""
                            :options="options">
                        </mt-radio>
                    </div>
                    <!-- 多选 -->
                    <div class="multsele" v-if="poll.type==1">
                        <mt-checklist
                            title=""
                            class="moreChioce"
                            @change="multple"
                            v-model="value2"
                            :options="options">
                        </mt-checklist>
                    </div>
                    <a href="javascript:;" class="voteBtn" @click="voteSet" v-if="!isEnd">投票</a>
                    <!-- 已投 -->
                    <div class="proBox">
                        <p>{{poll.title}}{{poll.type==1?'（多选）':'（单选）'}}</p>
                        <p class="title desc">{{poll.info}}</p>
                        <div class="item" v-for="(item,i) in poll.options" :key="i">
                            <p>
                                {{item.title}}{{item.isVote=='1'?'(已选)':''}}
                            </p>
                            <div class="gress clearfix">
                                <mt-progress :value="parseInt(Number((Number(item.votes)/Number(countNum))*100) || '0')" :bar-height="8"></mt-progress>
                                <div class="right">
                                    <span>{{item.votes}}票</span>
                                    <span class="perc">{{parseInt(Number((Number(item.votes)/Number(countNum))*100) || '0')}}%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <!-- if 未投票 单选框或者多选框 -->
                    <div v-if="isVote!=1">
                        <p class="title2">{{poll.title}}{{poll.type==1?'（多选）':'（单选）'}}</p>
                        <p class="title title2 desc">{{poll.info}}</p>
                        <div v-if="poll.type==0">
                            <mt-radio
                                @change="single"
                                v-model="value"
                                title=""
                                :options="options">
                            </mt-radio>
                        </div>
                        <!-- 多选 -->
                        <div class="multsele" v-if="poll.type==1">
                            <mt-checklist
                                title=""
                                class="moreChioce"
                                @change="multple"
                                v-model="value2"
                                :options="options">
                            </mt-checklist>
                        </div>
                        <a href="javascript:;" class="voteBtn" @click="voteSet" v-if="!isEnd">投票</a>
                    </div>
                    
                    <!-- else -->
                    <!-- 已投 -->
                    <div class="proBox" v-else>
                        <p>{{poll.title}}{{poll.type==1?'（多选）':'（单选）'}}</p>
                        <p class="title desc">{{poll.info}}</p>
                        <div class="item" v-for="(item,i) in poll.options" :key="i">
                            <p>{{item.title}}{{item.isVote=='1'?'(已选)':''}}</p>
                            <div class="gress clearfix">
                                <mt-progress :value="parseInt(Number((Number(item.votes)/Number(countNum))*100) || '0')" :bar-height="8"></mt-progress>
                                <div class="right">
                                    <span>{{item.votes}}票</span>
                                    <span class="perc">{{parseInt(Number((Number(item.votes)/Number(countNum))*100) || '0')}}%</span>
                                </div>
                            </div>
                        </div>
                        <p class="outDate alData">你已投票</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- 公众号遮罩 -->
        <div class="maskContent" v-show="isMask">
            <div class="mask">
                <div>
                    <img class="code" src="../../assets/imgs/db.jpg" alt="">
                </div>
                <p class="at">关注东坝微信投票查看结果</p>
                <!-- <p class="at">查看投票结果</p> -->
                <p class="gray">请在微信中打开长按识别二维码关注公众号</p>
                <img class="close" @click="closeMask" src="../../assets/imgs/circle3.png" alt="">
            </div>
        </div>
    </div>
</template>
<script>
import Top from "@/component/top/top";
import { Toast, MessageBox } from 'mint-ui'
import axios from '@/axios'
export default {
    components:{
        Top
    },
    data() {
        return {
            title:'投票',
            isMask:false,
            checkVal:'', //1弹二维码弹窗，0不弹出二维码
            iframeId:this.$route.query.iframeId || '',
            value:'',
            isVote:'',
            ornotModal:false,
            countNum:0,
            poll:{
                type:'',
                options:[],
                title:'',
                info:''
            },
            value2:[],
            options:[],
            isEnd:false,
            chioceVal:null,
            isAdmin:null,
        }
    },
    created() {
        // this.setuserToken('oIOCMI5du5M4TiNj3im45u7m7JN3ZC4n')
    },
    mounted() {
        // console.log('进来')
        // if(this.isAndroid()) {
        //     if(!this.myCommon.isIframe()) {
        //         if(window.parent.getToken()) {
        //             this.setuserToken(window.parent.getToken())
        //         }else{
        //             this.setuserToken('')
        //         }
        //     }else{
        //         window.app.postToken('postToken')
        //         window["getToken"] = token => {
        //             this.setuserToken(token)
        //         }
        //     }
        //     this.getDetail()
        // }else if(this.isIos()) {
        //     if(!this.myCommon.isIframe()) {
        //         if(window.parent.getToken()) {
        //             this.setuserToken(window.parent.getToken())
        //         }else{
        //             this.setuserToken('')
        //         }
        //     }else{
        //         window.webkit.messageHandlers.postToken.postMessage('')
        //         window.getToken = this.getToken
        //     }
        //     this.getDetail()
        // } else {
          if(this.$route.query.iframeId) {
              if(typeof(window.parent.getToken) == "function") {
                  this.setuserToken(window.parent.getToken())
              }
          }
          this.getDetail()
        // }
    },
    updated() {
        let _this = this
        if(this.$route.query.iframeId){
            this.$nextTick(()=>{ // 页面渲染完成后的回调
                // console.log(this.$refs.cxcontent.offsetHeight+20)
                window.parent.setIframeHeight(this.$route.query.iframeId,this.$refs.cxcontent.offsetHeight+20)
                _this.checkVal = window.parent.checkConcern() //返回1，0判断是否显示二维码弹窗
            })
        }
    },
    destroyed() {
    },
    methods:{
        // 关闭二维码
        closeMask() {
            // 5分钟有效期
            this.ornotModal = true
            this.isMask = false
        },
        postToken() {

        },
        getToken(token) {
            // this.setuserToken('H88YDuXYuaPjfK5unxUj5JGFD8YizaE8')
            this.setuserToken(token)
            // this.getDetail()
        },
        getDetail() {
            // axios.get(this.commonIp()+ `/v1/polls/${this.$route.query.id}?token=${this.getuserToken()}`).then((res) => {
            axios.get(`/v1/polls/${this.$route.query.id}`).then((res) => {
                this.poll = res.data.data.poll
                this.isVote = res.data.data.isVote
                this.isAdmin = res.data.data.isAdmin
                let currTime = res.data.data.poll.end_time - Date.parse(new Date())/1000
                if(currTime<0) {
                    this.isEnd = true
                }
                this.countNum = 0
                let c = 0
                res.data.data.poll.options.forEach((item,i) => {
                    let newObj = {}
                    this.countNum += item.votes
                    newObj["label"] = item.title
                    newObj["value"] = "" +item.option_id + ""
                    newObj["votes"] = item.votes
                    if(this.isEnd) {
                        newObj["disabled"] = true
                    }
                    if(this.isAdmin&&c == 0) {
                        this.options = []
                        this.options.push(newObj)
                        c++
                        return 
                    }else{
                        this.options.push(newObj)
                        c++
                    }
                });
            })
        },
        // 单选
        single(val) {
            this.chioceVal = JSON.parse('['+val+']')
        },
        // 多选
        multple(val) {
            this.chioceVal = val
        },
        intoVote(i) {
            if(i==1) {
                this.$router.push({path:'/svote?title=创建单选投票'})
            }else{
                this.$router.push({path:'/svote?title=创建多选投票'})
            }
        },
        goBack() {
            history.go(-1)
        },
        // 点击投票
        voteSet() {
            let _this = this
            // 判断登录未登录
                // 触屏版 app 跳转
            if (this.isAndroid() || this.isIos()) {
                if (!this.ischeckLogin()) {
                    window.location.href = "app://login";
                }else{
                    if(this.checkVal=='1') {
                        if(this.ornotModal) {
                            this.voteThings()
                        }else{
                            this.isMask = true
                        }
                    }else{
                        this.voteThings()
                    }
                }
            }else{
                if(this.$route.query.iframeId && typeof(window.parent.getToken) == "function" ) {
                    if(!this.getuserToken()) {
                        if(this.checkVal=='1') {
                            if(parent.confirm('请登录后参与投票')) {
                                parent.location.href = `${this.commonIp()}/quickLogin?referer=${encodeURIComponent(parent.location.href)}`;
                            }
                        }else{
                            parent.location.href = `${this.commonIp()}/quickLogin?referer=${encodeURIComponent(parent.location.href)}`;
                        }
                        return
                    }
                }
                if(this.checkVal=='1') {
                    if(this.ornotModal) {
                        this.voteThings()
                    }else{
                        this.isMask = true
                    }
                }else{
                    this.voteThings()
                }
            }
        },
        // 投票
        voteThings() {
            axios.post(this.commonIp()+'/v1/polls/vote',{
                id:this.$route.query.id,
                tid:this.$route.query.tid || '',
                options:this.chioceVal,
            }).then((res) => {
                if(this.isAndroid() || this.isIos()) {
                    if(res.data.code=='200') {
                        this.getDetail()
                    }else{
                        Toast(res.data.message)
                    }
                }else{
                    if(res.data.code=='200') {
                        this.getDetail()
                    }else if(res.data.code=='424') {
                        parent.location.href = `${this.commonIp()}/quickLogin?referer=${encodeURIComponent(parent.location.href)}`;
                    }else{
                        Toast(res.data.message)
                    }
                }
            })
        }
    }
}
</script>
<style lang="less">
@import "~@/assets/less/index.less";
    #chiocevote{
        position: relative;
        .maskContent{
            position: absolute;
            background: rgba(0,0,0,0.5);
            width:100%;
            height: 100%;
            top:0;
            .mask{
                text-align:center;
                position: absolute;
                width:80%;
                padding:10px;
                background: #fff;
                bottom:70px;
                margin-top:-172px;
                left: 50%;
                margin-left:-40%;
            }
            .at{
                font-size:13px;
                color:#02CB44;
                margin:0 0 10px 0;
            }
            .gray{
                font-size:12px;
                color:#757575;
            }
            .close{
                width:30px;
                height: 60px;
                position: absolute;
                bottom:-45px;
                left:50%;
                margin-left:-15px;
            }
            .code{
                width:200px;
            }
        }
        .moreChioce{
            .mint-checkbox-core{
                border-radius: 0;
            }
        }
        .mint-radiolist-title{
            display: none;
        }
        .mint-checkbox-input:checked + .mint-checkbox-core{
            background-color:#25cf8d;
            border-color:#25cf8d;
        }
        .mint-checklist-title{
            font-size:@ft16;
            color:#323232;
        }
        .mt-progress-runway{
            background-color:#edf4ff;
            border:1px solid #bababa;
        }
        .mt-progress{
            .fl();
        }
        .mt-progress-content{
            flex:0 0 160px;
            width:160px;
        }
        .mt-progress-progress{
            background:#25cf8d;
            border-radius: 0 18px 18px 0;
        }
        .bg{
            height: 10px;
            width:100%;
            background: #f2f2f2;
        }
        .chioceBox{
            .title{
                margin:10px 0;
            }
            .title2{
                padding:0 10px;
                margin-top:10px;
            }
            .singleBox{
                background: #f2f2f2;
                border:1px solid #e5e5e5;
                padding:10px 10px 0;
                .outDate{
                    text-align: center;
                    color:#949494;
                    padding:15px 0;
                    margin-top:10px;
                    border-bottom:1px solid #d8d8d8;
                    &.alData{
                        border-top:1px solid #d8d8d8;
                        border-bottom:0;
                    }
                    &.toutDate{
                        margin-top:0;
                        padding-top:0;
                    }
                }
                .mint-radio-input:checked + .mint-radio-core{
                    background:#25cf8d;
                }
                .mint-radiolist-title{
                    font-size:@ft16;
                    padding:5px 0 0 0;
                    color:#323232;
                }
                .mint-cell-wrapper{
                    background: #f2f2f2;
                    padding:0;
                    border-bottom:1px solid #d8d8d8;
                }
                .proBox{
                    padding:10px;
                    padding-bottom:0;
                    .gress{
                        height: 30px;
                        line-height: 30px;
                        .right{
                            .fr();
                            font-size:13px;
                            color:#949494;
                            .perc{
                                width:47px;
                                margin:0 0 0 10px;
                                display: inline-block;
                            }
                        }
                    }
                }
                .voteBtn{
                    text-align: center;
                    height: 51px;
                    line-height: 51px;
                    text-align: center;
                    color:#25cf8d;
                    display: block;
                }
            }
        }
    }
    @media screen and (max-width:320px){
        #chiocevote .mt-progress-content{
            flex:0 0 150px;
            width:auto;
        }
    }
</style>




// WEBPACK FOOTER //
// src/pages/chiocevote/chiocevote.vue